export const leeds = [
  {
    key: "Concrete",
    label: "Concrete",
    sub_categories: [
      { key: "Aggregates", label: "Aggregates" },
      { key: "Cement", label: "Cement" },
      { key: "CementBoard", label: "Cement Board" },
      { key: "CementGrout", label: "Cement Grout" },
      { key: "CementitiousMaterials", label: "Cementitious Materials" },
      { key: "CementitiousSheathingBoard", label: "Cementitious Sheathing Board" },
      { key: "Concrete", label: "Concrete" },
      { key: "ConcreteAdmixtures", label: "Concrete Admixtures" },
      { key: "ConcretePaving", label: "Concrete Paving" },
      { key: "FlowableFill", label: "Flowable Fill" },
      { key: "Grouting", label: "Grouting" },
      { key: "Mortar", label: "Mortar" },
      { key: "Plaster", label: "Plaster" },
      { key: "PrecastConcrete", label: "Precast Concrete" },
      { key: "ReadyMix", label: "Ready Mix" },
      { key: "Shotcrete", label: "Shotcrete" },
      { key: "SupplementaryCementitiousMaterials", label: "Supplementary Cementitious Materials" },
    ],
  },
  {
    key: "Masonry",
    label: "Masonry",
    sub_categories: [
      { key: "Brick", label: "Brick" },
      { key: "CMU", label: "Concrete Masonry Units (CMU)" },
      { key: "Masonry", label: "Masonry" },
      { key: "MasonryCement", label: "Masonry Cement" },
      { key: "StoneCladding", label: "Stone Cladding" },
      { key: "ArchitecturalPrecast", label: "Architectural Precast" },
      { key: "CivilPrecast", label: "Civil Precast" },
      { key: "StructuralPrecast", label: "Structural Precast" },
    ],
  },
  {
    key: "Metals",
    label: "Metals",
    sub_categories: [
      { key: "Aluminium", label: "Aluminium" },
      { key: "AluminiumBillets", label: "Aluminium Billets" },
      { key: "AluminiumExtrusions", label: "Aluminium Extrusions" },
      { key: "AluminiumSheetGoods", label: "Aluminium Sheet Goods" },
      { key: "AluminiumSiding", label: "Aluminium Siding" },
      { key: "AluminiumSuspensionAssembly", label: "Aluminium Suspension Assembly" },
      { key: "CoilSteel", label: "Coil Steel" },
      { key: "ColdFormedFraming", label: "Cold Formed Framing" },
      { key: "ColdFormedSteel", label: "Cold Formed Steel" },
      { key: "Copper", label: "Copper" },
      { key: "HotRolledSections", label: "Hot Rolled Sections" },
      { key: "MBQSteel", label: "MBQ Steel" },
      { key: "MiscMetalFabrication", label: "Miscellaneous Metal Fabrication" },
      { key: "PlateSteel", label: "Plate Steel" },
      { key: "Profiles", label: "Profiles" },
      { key: "RebarSteel", label: "Rebar Steel" },
      { key: "Steel", label: "Steel" },
      { key: "SteelSuspensionAssembly", label: "Steel Suspension Assembly" },
      { key: "WireMeshSteel", label: "Wire Mesh Steel" },
      { key: "Zinc", label: "Zinc" },
      { key: "ZincSiding", label: "Zinc Siding" },
    ],
  },
  {
    key: "Wood, Plastic & Composites",
    label: "Wood, Plastic & Composites",
    sub_categories: [
      { key: "CompositeLumber", label: "Composite Lumber" },
      { key: "CompositionSiding", label: "Composition Siding" },
      { key: "DimensionLumber", label: "Dimension Lumber" },
      { key: "HeavyTimber", label: "Heavy Timber" },
      { key: "MassTimber", label: "Mass Timber" },
      { key: "NonStructuralWood", label: "Non Structural Wood" },
      { key: "PrefabricatedWood", label: "Prefabricated Wood" },
      { key: "PrefabricatedWoodInsulatedPanels", label: "Prefabricated Wood Insulated Panels" },
      { key: "PrefabricatedWoodTruss", label: "Prefabricated Wood Truss" },
      { key: "SolidWoodSiding", label: "Solid Wood Siding" },
      { key: "UnfinishedWood", label: "Unfinished Wood" },
      { key: "Wood", label: "Wood" },
      { key: "WoodDecking", label: "Wood Decking" },
      { key: "WoodDoors", label: "Wood Doors" },
      { key: "WoodFlooring", label: "Wood Flooring" },
      { key: "WoodFraming", label: "Wood Framing" },
      { key: "WoodJoists", label: "Wood Joists" },
    ],
  },
  {
    key: "Thermal and Moisture Protection",
    label: "Thermal and Moisture Protection",
    sub_categories: [
      { key: "AirBarriers", label: "Air Barriers" },
      { key: "AppliedFireproofing", label: "Applied Fireproofing" },
      { key: "Asphalt", label: "Asphalt" },
      { key: "BituminousRoofing", label: "Bituminous Roofing" },
      { key: "DampproofingAndWaterproofing", label: "Dampproofing And Waterproofing" },
      { key: "FlashingAndSheetMetal", label: "Flashing And Sheet Metal" },
      { key: "InsulatedRoofPanels", label: "Insulated Roof Panels" },
      { key: "InsulatedWallPanels", label: "Insulated Wall Panels" },
      { key: "InsulatingGlazingUnits", label: "Insulating Glazing Units" },
      { key: "Insulation", label: "Insulation" },
      { key: "IntumescentFireproofing", label: "Intumescent Fireproofing" },
      { key: "MembraneRoofing", label: "Membrane Roofing" },
      { key: "RoofCoverBoards", label: "Roof Cover Boards" },
      { key: "RoofPanels", label: "Roof Panels" },
      { key: "Siding", label: "Siding" },
      { key: "SinglePlyEPDM", label: "Single Ply EPDM" },
      { key: "SinglePlyKEE", label: "Single Ply KEE" },
      { key: "SinglePlyOther", label: "Single Ply Other" },
      { key: "SinglePlyPolyurethane", label: "Single Ply Polyurethane" },
      { key: "SinglePlyPVC", label: "Single Ply PVC" },
      { key: "SinglePlyTPO", label: "Single Ply TPO" },
      { key: "WeatherBarriers", label: "Weather Barriers" },
    ],
  },
  {
    key: "Openings",
    label: "Openings",
    sub_categories: [
      { key: "DoorsAndFrames", label: "Doors And Frames" },
      { key: "DoorsHardware", label: "Doors Hardware" },
      { key: "GlazedDoors", label: "Glazed Doors" },
      { key: "SlidingGlassDoors", label: "Sliding Glass Doors" },
      { key: "SpecialFunctionDoors", label: "Special Function Doors" },
      { key: "Storefronts", label: "Storefronts" },
      { key: "TranslucentWallAndRoofAssemblies", label: "Translucent Wall And Roof Assemblies" },
      { key: "UnitSkylights", label: "Unit Skylights" },
      { key: "Windows", label: "Windows" },
    ],
  },
  {
    key: "Finishings",
    label: "Finishings",
    sub_categories: [
      { key: "AcousticalCeilings", label: "Acoustical Ceilings" },
      { key: "Carpet", label: "Carpet" },
      { key: "CarpetFiber", label: "Carpet Fiber" },
      { key: "CeilingPanel", label: "Ceiling Panel" },
      { key: "Cladding", label: "Cladding" },
      { key: "Finishes", label: "Finishes" },
      { key: "Flooring", label: "Flooring" },
      { key: "FlooringAccessories", label: "Flooring Accessories" },
      { key: "GaugedTile", label: "Gauged Tile" },
      { key: "GlassTile", label: "Glass Tile" },
      { key: "Laminate", label: "Laminate" },
      { key: "PaintByArea", label: "Paint By Area" },
      { key: "PaintByMass", label: "Paint By Mass" },
      { key: "PaintByVolume", label: "Paint By Volume" },
      { key: "PaintingAndCoating", label: "Painting And Coating" },
      { key: "ResilientFlooring", label: "Resilient Flooring" },
      { key: "TileGrout", label: "Tile Grout" },
      { key: "Tiling", label: "Tiling" },
      { key: "WallBase", label: "Wall Base" },
      { key: "WallFinishes", label: "Wall Finishes" },
      { key: "WallPanels", label: "Wall Panels" },
    ],
  },
  {
    key: "Plumbing",
    label: "Plumbing",
    sub_categories: [
      { key: "Bathtubs", label: "Bathtubs" },
      { key: "Faucets", label: "Faucets" },
      { key: "PlumbingFixtures", label: "Plumbing Fixtures" },
      { key: "OtherPlumbingFixtures", label: "Other Plumbing Fixtures" },
      { key: "WaterClosets", label: "Water Closets" },
      { key: "WaterHeaters", label: "Water Heaters" },
    ],
  },
  {
    key: "Electrical",
    label: "Electrical",
    sub_categories: [
      { key: "AcTransformers", label: "AC Transformers" },
      { key: "Batteries", label: "Batteries" },
      { key: "DataCabling", label: "Data Cabling" },
      { key: "Electrical", label: "Electrical" },
      { key: "ElectricalBuses", label: "Electrical Buses" },
      { key: "ElectricalConduit", label: "Electrical Conduit" },
      { key: "ElectricalGenerationEquipment", label: "Electrical Generation Equipment" },
      { key: "ElectricalSwitchgear", label: "Electrical Switchgear" },
      { key: "ElectricityFromSpecificGenerator", label: "Electricity From Specific Generator" },
      { key: "ElectricPower", label: "Electric Power" },
      { key: "LightingControls", label: "Lighting Controls" },
      { key: "LightingFixtures", label: "Lighting Fixtures" },
      { key: "LowVoltBuses", label: "Low Volt Buses" },
      { key: "NetworkingCableTrays", label: "Networking Cable Trays" },
      { key: "NetworkingRaceways", label: "Networking Raceways" },
      { key: "OtherElectricalEquipment", label: "Other Electrical Equipment" },
      { key: "OutdoorLighting", label: "Outdoor Lighting" },
      { key: "PDU", label: "Power Distribution Unit (PDU)" },
      { key: "Photovoltaics", label: "Photovoltaics" },
      { key: "PowerCabling", label: "Power Cabling" },
      { key: "PowerDistributionUnits", label: "Power Distribution Units" },
      { key: "SpecialtyLighting", label: "Specialty Lighting" },
      { key: "WindTurbines", label: "Wind Turbines" },
    ],
  },
  {
    key: "Exterior Improvements",
    label: "Exterior Improvements",
    sub_categories: [
      { key: "AccessFlooring", label: "Access Flooring" },
      { key: "AccessFlooringPedestals", label: "Access Flooring Pedestals" },
      { key: "CurtainWalls", label: "Curtain Walls" },
      { key: "ExteriorSunControlDevices", label: "Exterior Sun Control Devices" },
      { key: "FenestrationAccessories", label: "Fenestration Accessories" },
      { key: "FenestrationFraming", label: "Fenestration Framing" },
      { key: "FenestrationHardware", label: "Fenestration Hardware" },
      { key: "FiberCementSiding", label: "Fiber Cement Siding" },
      { key: "MetalSiding", label: "Metal Siding" },
      { key: "VinylSiding", label: "Vinyl Siding" },
    ],
  },
];
export const leeds_flat = {
  Aggregates: "Aggregates",
  Cement: "Cement",
  CementBoard: "Cement Board",
  CementGrout: "Cement Grout",
  CementitiousMaterials: "Cementitious Materials",
  CementitiousSheathingBoard: "Cementitious Sheathing Board",
  Concrete: "Concrete",
  ConcreteAdmixtures: "Concrete Admixtures",
  ConcretePaving: "Concrete Paving",
  FlowableFill: "Flowable Fill",
  Grouting: "Grouting",
  Mortar: "Mortar",
  Plaster: "Plaster",
  PrecastConcrete: "Precast Concrete",
  ReadyMix: "Ready Mix",
  Shotcrete: "Shotcrete",
  SupplementaryCementitiousMaterials: "Supplementary Cementitious Materials",
  Brick: "Brick",
  CMU: "Concrete Masonry Units (CMU)",
  Masonry: "Masonry",
  MasonryCement: "Masonry Cement",
  StoneCladding: "Stone Cladding",
  ArchitecturalPrecast: "Architectural Precast",
  CivilPrecast: "Civil Precast",
  StructuralPrecast: "Structural Precast",
  Aluminium: "Aluminium",
  AluminiumBillets: "Aluminium Billets",
  AluminiumExtrusions: "Aluminium Extrusions",
  AluminiumSheetGoods: "Aluminium Sheet Goods",
  AluminiumSiding: "Aluminium Siding",
  AluminiumSuspensionAssembly: "Aluminium Suspension Assembly",
  CoilSteel: "Coil Steel",
  ColdFormedFraming: "Cold Formed Framing",
  ColdFormedSteel: "Cold Formed Steel",
  Copper: "Copper",
  HotRolledSections: "Hot Rolled Sections",
  MBQSteel: "MBQ Steel",
  MiscMetalFabrication: "Miscellaneous Metal Fabrication",
  PlateSteel: "Plate Steel",
  Profiles: "Profiles",
  RebarSteel: "Rebar Steel",
  Steel: "Steel",
  SteelSuspensionAssembly: "Steel Suspension Assembly",
  WireMeshSteel: "Wire Mesh Steel",
  Zinc: "Zinc",
  ZincSiding: "Zinc Siding",
  CompositeLumber: "Composite Lumber",
  CompositionSiding: "Composition Siding",
  DimensionLumber: "Dimension Lumber",
  HeavyTimber: "Heavy Timber",
  MassTimber: "Mass Timber",
  NonStructuralWood: "Non Structural Wood",
  PrefabricatedWood: "Prefabricated Wood",
  PrefabricatedWoodInsulatedPanels: "Prefabricated Wood Insulated Panels",
  PrefabricatedWoodTruss: "Prefabricated Wood Truss",
  SolidWoodSiding: "Solid Wood Siding",
  UnfinishedWood: "Unfinished Wood",
  Wood: "Wood",
  WoodDecking: "Wood Decking",
  WoodDoors: "Wood Doors",
  WoodFlooring: "Wood Flooring",
  WoodFraming: "Wood Framing",
  WoodJoists: "Wood Joists",
  AirBarriers: "Air Barriers",
  AppliedFireproofing: "Applied Fireproofing",
  Asphalt: "Asphalt",
  BituminousRoofing: "Bituminous Roofing",
  DampproofingAndWaterproofing: "Dampproofing And Waterproofing",
  FlashingAndSheetMetal: "Flashing And Sheet Metal",
  InsulatedRoofPanels: "Insulated Roof Panels",
  InsulatedWallPanels: "Insulated Wall Panels",
  InsulatingGlazingUnits: "Insulating Glazing Units",
  Insulation: "Insulation",
  IntumescentFireproofing: "Intumescent Fireproofing",
  MembraneRoofing: "Membrane Roofing",
  RoofCoverBoards: "Roof Cover Boards",
  RoofPanels: "Roof Panels",
  Siding: "Siding",
  SinglePlyEPDM: "Single Ply EPDM",
  SinglePlyKEE: "Single Ply KEE",
  SinglePlyOther: "Single Ply Other",
  SinglePlyPolyurethane: "Single Ply Polyurethane",
  SinglePlyPVC: "Single Ply PVC",
  SinglePlyTPO: "Single Ply TPO",
  WeatherBarriers: "Weather Barriers",
  DoorsAndFrames: "Doors And Frames",
  DoorsHardware: "Doors Hardware",
  GlazedDoors: "Glazed Doors",
  SlidingGlassDoors: "Sliding Glass Doors",
  SpecialFunctionDoors: "Special Function Doors",
  Storefronts: "Storefronts",
  TranslucentWallAndRoofAssemblies: "Translucent Wall And Roof Assemblies",
  UnitSkylights: "Unit Skylights",
  Windows: "Windows",
  AcousticalCeilings: "Acoustical Ceilings",
  Carpet: "Carpet",
  CarpetFiber: "Carpet Fiber",
  CeilingPanel: "Ceiling Panel",
  Cladding: "Cladding",
  Finishes: "Finishes",
  Flooring: "Flooring",
  FlooringAccessories: "Flooring Accessories",
  GaugedTile: "Gauged Tile",
  GlassTile: "Glass Tile",
  Laminate: "Laminate",
  PaintByArea: "Paint By Area",
  PaintByMass: "Paint By Mass",
  PaintByVolume: "Paint By Volume",
  PaintingAndCoating: "Painting And Coating",
  ResilientFlooring: "Resilient Flooring",
  TileGrout: "Tile Grout",
  Tiling: "Tiling",
  WallBase: "Wall Base",
  WallFinishes: "Wall Finishes",
  WallPanels: "Wall Panels",
  Bathtubs: "Bathtubs",
  Faucets: "Faucets",
  PlumbingFixtures: "Plumbing Fixtures",
  OtherPlumbingFixtures: "Other Plumbing Fixtures",
  WaterClosets: "Water Closets",
  WaterHeaters: "Water Heaters",
  AcTransformers: "AC Transformers",
  Batteries: "Batteries",
  DataCabling: "Data Cabling",
  Electrical: "Electrical",
  ElectricalBuses: "Electrical Buses",
  ElectricalConduit: "Electrical Conduit",
  ElectricalGenerationEquipment: "Electrical Generation Equipment",
  ElectricalSwitchgear: "Electrical Switchgear",
  ElectricityFromSpecificGenerator: "Electricity From Specific Generator",
  ElectricPower: "Electric Power",
  LightingControls: "Lighting Controls",
  LightingFixtures: "Lighting Fixtures",
  LowVoltBuses: "Low Volt Buses",
  NetworkingCableTrays: "Networking Cable Trays",
  NetworkingRaceways: "Networking Raceways",
  OtherElectricalEquipment: "Other Electrical Equipment",
  OutdoorLighting: "Outdoor Lighting",
  PDU: "Power Distribution Unit (PDU)",
  Photovoltaics: "Photovoltaics",
  PowerCabling: "Power Cabling",
  PowerDistributionUnits: "Power Distribution Units",
  SpecialtyLighting: "Specialty Lighting",
  WindTurbines: "Wind Turbines",
  AccessFlooring: "Access Flooring",
  AccessFlooringPedestals: "Access Flooring Pedestals",
  CurtainWalls: "Curtain Walls",
  ExteriorSunControlDevices: "Exterior Sun Control Devices",
  FenestrationAccessories: "Fenestration Accessories",
  FenestrationFraming: "Fenestration Framing",
  FenestrationHardware: "Fenestration Hardware",
  FiberCementSiding: "Fiber Cement Siding",
  MetalSiding: "Metal Siding",
  VinylSiding: "Vinyl Siding",
};
export const getCategoriesKeys = () => leeds.map((l) => l.key);
export const getSubCategoriesKeysByCategory = (category) => {
  const match = leeds.find((l) => l.key === category);
  return match ? match.sub_categories.map((s) => s.key) : [];
};
